import { createSelector } from 'reselect'
import { selectHasRecentLoan } from 'src/store/selectors/home'
import { selectRefiDetails } from 'src/store/selectors/refinance'
import {
  selectRefiEligible,
  selectCurrentCELs
} from 'src/store/selectors/home/loans'
import {
  selectLeverageableEquityForLTV,
  selectEmergencyReservePool,
  CASHOUT_LTV,
  CASHOUT_MINIMUM,
  EMERGENCY_RESERVE_MINIMUM
} from 'src/store/selectors/home/equity'
import { selectCompanyHasWINMortgagePaymentOptions } from 'src/store/selectors/customerProfile'

// Duplicating logic in RefiByYearsInHomeContainer
export const selectShouldRenderRefiOptions = createSelector(
  selectHasRecentLoan,
  selectRefiDetails,
  (hasRecentLoan, refiDetails) =>
    !hasRecentLoan && refiDetails && refiDetails.length > 0
)

// Duplicating logic in withEquityAndPurchasingPowerProps and CashoutContainer
export const selectShouldRenderCashout = createSelector(
  selectRefiEligible,
  selectLeverageableEquityForLTV(CASHOUT_LTV),
  (eligible, excess) => eligible && excess >= CASHOUT_MINIMUM
)

export const selectShouldRenderEmergencyReserve = createSelector(
  selectShouldRenderCashout,
  selectEmergencyReservePool,
  (showCashout, pool) => showCashout && pool >= EMERGENCY_RESERVE_MINIMUM
)

export const selectShouldRenderMortgageRelief = createSelector(
  selectCompanyHasWINMortgagePaymentOptions,
  selectCurrentCELs,
  (featureCheck, currentCELs) =>
    featureCheck && currentCELs && currentCELs.length > 0
)
